import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "src/app/store/hooks";
import { useClipboard } from "@mantine/hooks";
import { ActionIcon, Group, Title } from "@mantine/core";
import { MdOutlineCheck, MdOutlineContentCopy, MdOutlineEdit } from "react-icons/md";
import { showActionPointsModal } from "src/features/conversation/conversationSlice";
const ActionPointsTitle = ({ text }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const clipboard = useClipboard({ timeout: 500 });
    return (_jsxs(Group, { justify: "space-between", children: [_jsx(Title, { order: 6, fw: "bold", children: t('Action.points_') }), _jsxs(Group, { gap: 0, children: [_jsx(ActionIcon, { color: clipboard.copied ? 'green' : 'primary', variant: "transparent", "aria-label": "Copy", onClick: () => clipboard.copy(text), children: clipboard.copied ? _jsx(MdOutlineCheck, { size: 18 }) : _jsx(MdOutlineContentCopy, { size: 18 }) }), _jsx(ActionIcon, { variant: "transparent", "aria-label": "Edit", onClick: () => {
                            dispatch(showActionPointsModal());
                        }, children: _jsx(MdOutlineEdit, { size: 18 }) })] })] }));
};
export default ActionPointsTitle;
